(function(angular){
	'use strict';
	
	angular
		.module('mapboxGLModule', [])
		.value('mapboxgl', mapboxgl);

})(window.angular);